export default __webpack_public_path__ + "static/media/runners.b11cd585.png";